import { DatabaseUsers } from '../../shared/types/types';
import { MeetingDataI } from '../../shared/types/MeetingData';
import { mapDatabaseUsersToUsers } from '../../utils/user/UserDataUtils';
import calculateUserPermissions from './meetingData_DataManipulation';
import SDate from '../../shared/classes/SDate';

const mapDatabaseMeetingDataToMeetingData = (
  meetingId: string,
  databaseData: any,
  userId: string,
): MeetingDataI => {
  const newData: MeetingDataI = {
    resolvedState: 'resolved',
    attendees: {
      attendees: [],
      resolvedState: 'pending',
    },
    userRole: calculateUserPermissions(userId, databaseData?.permissions),
    version: databaseData.version ?? '1',
    meetingId,
    data: {
      agenda: databaseData.data?.agenda ?? [],
      attachments: databaseData.data?.attachments ?? [],
      attendees: databaseData.data?.attendees ?? [],
      description: databaseData.data?.description ?? '',
      title: databaseData.data?.title ?? '',
      postMeetingTasks: databaseData.data?.post_meeting_tasks
        ?? databaseData.data?.postMeetingTasks ?? [],
      preMeetingTasks: databaseData.data?.pre_meeting_tasks
        ?? databaseData.data?.preMeetingTasks ?? [],
    },
    tags: {
      tags: databaseData?.tags?.tags ?? [],
      meetingSeries: databaseData?.tags?.meeting_series ?? databaseData?.tags?.meetingSeries ?? {
        name: '',
        id: '',
      },
    },
    date: {
      created: databaseData.date?.created ?? SDate.makeDummyDate().value,
      start: databaseData.date?.start ?? SDate.makeDummyDate().value,
      end: databaseData.date?.end ?? SDate.makeDummyDate().value,
      lastUpdated: databaseData.date?.lastUpdated ?? SDate.makeDummyDate().value,
    },
    googleData: {
      ids: {
        eventId: databaseData?.googleData?.ids?.eventId ?? '',
        recurringEventId: databaseData?.googleData?.ids?.recurringEventId ?? '',
        dataEventId: databaseData?.googleEventId ?? databaseData?.googleData?.ids?.dataEventId ?? '',
        meetId: databaseData.googleMeetId ?? databaseData?.googleData?.ids?.meetId ?? '',
        calendarId: databaseData?.googleData?.ids?.calendarId ?? '',
        htmlLink: databaseData?.googleData?.ids?.htmlLink ?? '',
      },
      content: {
        summary: databaseData?.googleData?.content?.summary ?? '',
        status: databaseData?.googleData?.content?.status ?? '',
        organizer: {
          email: databaseData?.googleData?.content?.organizer?.email ?? '',
        },
        creator: {
          email: databaseData?.googleData?.content?.creator?.email ?? '',
        },
      },
      conferenceData: {
        type: databaseData?.googleData?.conferenceData?.type ?? 'undefined',
        link: databaseData?.googleData?.conferenceData?.link ?? '',
      },
      attendees: databaseData?.googleData?.attendees ?? [],
    },
    permissions: {
      users: mapDatabaseUsersToUsers(
        databaseData.permissions?.users as DatabaseUsers,
      ),
      userGroups: databaseData.permissions?.user_groups ?? [],
      tags: databaseData.permissions?.tags ?? [],
      linkPermissions: databaseData?.permissions?.linkPermissions ?? 'private',
    },
  };
  return newData;
};

export default mapDatabaseMeetingDataToMeetingData;
